jQuery(document).ready(function ($) {

  function openAccordionByIndex(index) {
    var $accordion = $('.feature_accordion_cd7c');
    var $item      = $accordion.find('.feature_item').eq(index);
    if (!$item.length) return;

    var $toggle = $item.find('.feature_toggle');
    var $panel  = $item.find('.feature_panel');

    // Close all
    $accordion.find('.feature_panel').slideUp(0);
    $accordion.find('.feature_toggle').removeClass('active');

    // Open target
    $toggle.addClass('active');
    $panel.slideDown(0);
  }

  function scrollToSocialReport() {
    var $target = $('#national-donations-highlights');
    if (!$target.length) return;

    $('html, body').animate({
      scrollTop: $target.offset().top + 400
    }, 600, function () {
      openAccordionByIndex(1); // second accordion
    });
  }

  // OPEN FIRST ACCORDION BY DEFAULT
  openAccordionByIndex(0);

  // ACCORDION CLICK HANDLER
  $(document).on('click', '.feature_accordion_cd7c .feature_toggle', function (e) {
    e.preventDefault();

    var $toggle = $(this);
    var $item   = $toggle.closest('.feature_item');
    var $panel  = $item.find('.feature_panel');

    $('.feature_accordion_cd7c .feature_panel').not($panel).slideUp();
    $('.feature_accordion_cd7c .feature_toggle').not($toggle).removeClass('active');

    if ($toggle.hasClass('active')) {
      $toggle.removeClass('active');
      $panel.slideUp();
    } else {
      $toggle.addClass('active');
      $panel.slideDown();
    }
  });

  // CLICK HANDLER FOR #social-report LINKS
  $(document).on('click', 'a[href="#social-report"]', function (e) {
    e.preventDefault();
    history.pushState(null, '', '#social-report');
    scrollToSocialReport();
  });

  // HANDLE DIRECT LOAD WITH HASH
  if (window.location.hash === '#social-report') {
    // slight delay to ensure layout + VC modules are ready
    setTimeout(scrollToSocialReport, 300);
  }

});
